import axios from 'axios';

let cancelTokenSources = [];

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : '/',
});

// Compatibility shim for legacy services that call axiosInstance.create(...).
axiosInstance.create = function create(config = {}) {
  return axios.create({
    ...axiosInstance.defaults,
    ...config,
  });
};

export function getNewCancelToken() {
  const source = axios.CancelToken.source();
  cancelTokenSources.push(source);
  return source.token;
}

export function cancelPendingRequests() {
  cancelTokenSources.forEach(source => source.cancel('Request Cencelled.'));
  cancelTokenSources = [];
}

const token = localStorage.getItem('mantraz_auth_token');
if (token) {
  axiosInstance.defaults.headers.common.Authentication = token;
}

export default axiosInstance;
